import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'create-subproject-btn-tile',
  templateUrl: './create-subproject-btn-tile.component.html',
  styleUrls: ['./create-subproject-btn-tile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CreateSubprojectBtnTileComponent {
  @Input() small = false;
  @Input() additionalClass: string;

  @Output() submitAction: EventEmitter<boolean> = new EventEmitter();

  click(): void {
    this.submitAction.next(true);
  }

  constructor() {}
}
